import React, {  useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../components/LanguageSelect";
import { LANGUAGE_STORAGE_KEY } from "../i18n";
import "./Navbar.css"; // Import CSS file for styling
import "../components/ModalPopup.css";
import { getFirstSixLetters } from "../constant/constant";
import { NavLink, useLocation} from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsStaggered,faVideo,faQuestionCircle,faStar,faWallet, faUser, faClockRotateLeft, faArrowLeft, faRightFromBracket, faXmark, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import NavImage from "./NavImage";
import useModalTransition, { useScrollLock } from "../hooks/useModalTransition";
import useGoBack from "../hooks/useGoBack";
const SIDEBAR_ITEMS = [
  { to: "/account-statement", label: "nav.accountStatement", icon: faClockRotateLeft },
  { to: "/game-rates", label: "nav.gameRates", icon: faStar },
  { to: "/privacy-policy", label: "nav.terms", icon: faQuestionCircle },
  { to: "/how-to-play", label: "nav.video", icon: faVideo },
];

// Page titles shown in the top bar (keys under pageTitles.*)
const ROUTE_TITLES = {
  "/profile": "profile",
  "/privacy-policy": "privacyPolicy",
  "/how-to-play": "howToPlay",
  "/payment-status": "paymentStatus",
  "/game-rates": "gameRates",
  "/my-bid": "bidHistory",
  "/all-bid": "allBids",
  "/account-statement": "accountStatement",
  "/deposit": "deposit",
  "/withdraw": "withdrawal",
  "/wallet_histroy": "walletManagement",
  "/add_fund_auto": "addFundUpi",
  "/add_fund_user": "addFundManual",
  "/add_bank_details": "bankDetails",
  "/request_history": "depositHistory",
};

export default function Navbar() {
  const { t } = useTranslation();
  const { Info } = useSelector((state) => state.users);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [pageName, setpageName] = useState('');
  const location = useLocation();
  // Servers redirect /home to /home/ (public/home is also an image folder), so ignore a trailing slash
  const currentPath = location.pathname.replace(/\/+$/, '') || '/';
  const isHomePage = currentPath === '/' || currentPath === '/home';


  // Back one page, or Home when there is no earlier in-app page
  const handleBackClick = useGoBack("/home");

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const closeSidebar = () => {
    setSidebarOpen(false);
  };
  useScrollLock(isSidebarOpen, closeSidebar);

  const [isLogoutOpen, setLogoutOpen] = useState(false);
  const openLogout = () => {
    closeSidebar();
    setLogoutOpen(true);
  };
  const closeLogout = () => setLogoutOpen(false);
  const { isMounted: isLogoutMounted, isClosing: isLogoutClosing } = useModalTransition(isLogoutOpen, closeLogout);

  const logoutComp =()=>{
    // The push-notification token belongs to the device, not the user, so it survives logout
    const fcmToken = localStorage.getItem('fcm_token');
    const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    localStorage.clear();
    if (fcmToken) localStorage.setItem('fcm_token', fcmToken);
    // The chosen language is a device preference too
    if (language) localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    // replace() so Back can't return to a logged-in page
    window.location.replace(`${process.env.PUBLIC_URL}/login`);
  }

  const  toNormalCase=(str)=> {
    return str
      .toLowerCase() // Ensure the entire string is lowercase
      .split(' ')    // Split the string into an array of words
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1); // Capitalize the first letter of each word
      })
      .join(' ');    // Join the array back into a string
  }

  useEffect(()=>{
    if(currentPath.includes('fund_histry')){
      const fundType = currentPath.split('/')[currentPath.split('/')?.length-1] || '';
      setpageName(t(`history.fundTitles.${fundType}`, { defaultValue: toNormalCase(fundType.split('_').join(' ')) }));
    }else if(currentPath.includes('game_type')){
      setpageName(currentPath.split('/')[3-1]?.split('_').join(' '));
    }else if(ROUTE_TITLES[currentPath]){
      setpageName(t(`pageTitles.${ROUTE_TITLES[currentPath]}`));
    }else{
      setpageName(currentPath.split('/')[currentPath.split('/')?.length-1]?.split('_').join(' '));
    }
  },[currentPath, t]);


  // const handlePageClick = (event) => {
  //   if (!event.target.classList.contains("missed")) {
  //    setIsMenuOpen(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handlePageClick);
  //   return () => {
  //     document.removeEventListener("click", handlePageClick);
  //   };
  // }, []);


  
  return (
    // <nav className="navbar">
    //   <div className="navbar-container">
    //     {/* Logo */}
    //     <Link to="/" className="navbar-logo">
    //       {APP_NAME}
    //     </Link>

    //     {/* Desktop Links */}
    //     <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
    //       <li><Link to="/">Home</Link></li>
    //       {(Info?.status=='1')?<><li><Link to="/profile">My Profile</Link></li>
    //       <li><Link to="/my-bid">My Bid</Link></li>
    //       <li><Link to="/account-statement">Account Statement</Link></li>
    //       <li><Link to="/game-rates">Game Rates</Link></li>
    //       <li><Link to="/how-to-play">How to Play</Link></li>
    //       <li><Link to="/privacy-policy">Privacy Policy</Link></li></>:<></>}
    //       <li><Link to="/logout" onClick={logoutComp}>Logout</Link></li>
    //     </ul>

    //     {/* Toggle Button for Mobile */}
    //     <button className="menu-toggle missed"  onClick={toggleMenu}>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //     </button>
    //   </div>
    // </nav>

    <div id="app__" style={{position:'fixed',width:'100%',zIndex:'9900'}}>
      {/* Header */}
      <header className="header app-topbar">
        {isHomePage?<button type="button" onClick={toggleSidebar} className="topbar-btn" aria-label={t('common.openMenu')}>
          <FontAwesomeIcon icon={faBarsStaggered} />
        </button>:<button type="button" className="topbar-btn" onClick={handleBackClick} aria-label={t('common.goBack')}><FontAwesomeIcon icon={faArrowLeft} /></button>}
        {isHomePage?<div className="topbar-brand"><NavImage/></div>:<div className="header-page-title">{pageName}</div>}

        {Info?.status==='1'&&<div className="topbar-wallet" aria-label={t('nav.walletBalance')}>
          <span className="topbar-wallet-icon" aria-hidden="true"><FontAwesomeIcon icon={faWallet} /></span>
          <span className="topbar-wallet-amount">₹{Info?.wallet}</span>
        </div>}
      </header>

      {/* Sidebar */}
      <div className={`sidebar-overlay ${isSidebarOpen ? "open" : ""}`} onClick={closeSidebar} aria-hidden="true" />
      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-profile">
            <span className="sidebar-avatar" aria-hidden="true">
              {Info?.name ? Info.name.trim().charAt(0).toUpperCase() : <FontAwesomeIcon icon={faUser} />}
            </span>
            <div className="sidebar-user">
              <span className="sidebar-name nrwap">{getFirstSixLetters(Info?.name)}</span>
              <span className="sidebar-meta nrwap">+91{Info?.phone_number}</span>
              {Info?.created_at && <span className="sidebar-meta nrwap">{t('nav.since', { date: Info?.created_at })}</span>}
            </div>
          </div>
          <button type="button" onClick={closeSidebar} className="sidebar-close" aria-label={t('common.closeMenu')}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        {Info?.status==='1' && (
          <div className="sidebar-wallet">
            <FontAwesomeIcon icon={faWallet} />
            <span>{t('nav.walletBalance')}</span>
            <strong>₹{Info?.wallet}</strong>
          </div>
        )}
        <div className="sidebar-language">
          <span className="sidebar-section-label">{t('language.label')}</span>
          <LanguageSelect variant="card" />
        </div>
        <nav aria-label={t('nav.menu')}>
          <ul className="menu_left sidebar-menu">
            {Info?.status==='1' && SIDEBAR_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink to={item.to} onClick={closeSidebar} className={({ isActive }) => `sidebar-item${isActive ? ' is-active' : ''}`}>
                  <span className="sidebar-item-icon" aria-hidden="true"><FontAwesomeIcon icon={item.icon} fixedWidth /></span>
                  <span className="sidebar-item-label">{t(item.label)}</span>
                  <FontAwesomeIcon icon={faChevronRight} className="sidebar-item-chevron" />
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-footer">
          <button type="button" className="sidebar-logout" onClick={openLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} fixedWidth />
            <span>{t('nav.logout')}</span>
          </button>
          <p className="sidebar-version">{t('nav.appVersion', { version: '3.0' })}</p>
        </div>
      </aside>

      {/* Logout confirmation */}
      {isLogoutMounted && (
        <div className={`modal-overlay${isLogoutClosing ? ' is-closing' : ''}`} onClick={(e) => e.target === e.currentTarget && closeLogout()}>
          <div className="modal-content confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="logout-title">
            <div className="confirm-icon" aria-hidden="true"><FontAwesomeIcon icon={faRightFromBracket} /></div>
            <h2 id="logout-title" className="confirm-title">{t('nav.logoutTitle')}</h2>
            <p className="confirm-text">{t('nav.logoutText')}</p>
            <div className="confirm-actions">
              <button type="button" className="modal-btn modal-btn-secondary" onClick={closeLogout}>{t('common.cancel')}</button>
              <button type="button" className="modal-btn modal-btn-danger" onClick={logoutComp}>{t('nav.logout')}</button>
            </div>
          </div>
        </div>
      )}
      </div>
  );
}
